import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { ClaimService } from '../../service/claim.service';
import { ModalSendClaimComponent } from "./components/modal-send-claim/modal-send-claim.component";
import { OutgoingMessage } from 'http';

@Component({
  selector: 'request-claim',
  imports: [CommonModule, ModalSendClaimComponent],
  templateUrl: './request-claim.component.html',
  styleUrl: './request-claim.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestClaimComponent {
  @ViewChild(ModalSendClaimComponent) modalSendClaimComponent!: ModalSendClaimComponent;
  @Output() loadEventE = new EventEmitter<void>();
  claimService = inject(ClaimService);

  onReportProblem() {
    this.modalSendClaimComponent.openModal();
  }

  loadEvent() {
    this.loadEventE.emit();
  }
}
